var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEightball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext1_2",
    x: 0.0917969,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext1_2_i",
    d: "M20.0918 17C19.2598 17 18.7375 17.2674 18.4598 17.7194C18.2161 18.1162 18.2165 18.5832 18.2168 18.8495L18.2168 18.875C18.2168 19.2547 18.338 19.6499 18.6722 19.944C18.6981 19.9668 18.7249 19.9886 18.7526 20.0095C18.6348 20.1054 18.5377 20.2177 18.4599 20.3444C18.2161 20.7412 18.2166 21.2082 18.2169 21.4745L18.2169 21.5C18.2169 21.8797 18.3381 22.2749 18.6723 22.569C18.9995 22.8569 19.4769 23 20.0919 23C20.6868 23 21.1598 22.8549 21.4895 22.5722C21.8254 22.2841 21.9669 21.8921 21.9669 21.5L21.9669 21.4644C21.9673 21.1541 21.9679 20.6813 21.7197 20.2957C21.6438 20.1779 21.5507 20.0752 21.4395 19.9881C21.4565 19.9748 21.4731 19.9611 21.4894 19.9472C21.8253 19.6591 21.9668 19.2671 21.9668 18.875L21.9669 18.8394C21.9673 18.5291 21.9679 18.0563 21.7196 17.6707C21.4344 17.2277 20.9052 17 20.0918 17ZM20.0919 19.625C19.4705 19.625 19.1169 19.2053 19.1169 18.6875C19.1169 18.1697 19.4705 17.75 20.0919 17.75C20.7132 17.75 21.091 18.1697 21.091 18.6875C21.091 19.2053 20.7132 19.625 20.0919 19.625ZM21.091 21.3125C21.091 21.8303 20.7133 22.25 20.0919 22.25C19.4706 22.25 19.1169 21.8303 19.1169 21.3125C19.1169 20.7947 19.4706 20.375 20.0919 20.375C20.7133 20.375 21.091 20.7947 21.091 21.3125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ext1_2_i",
    d: "M20.0918 30.5C25.8908 30.5 30.5918 25.799 30.5918 20C30.5918 14.201 25.8908 9.5 20.0918 9.5C14.2928 9.5 9.5918 14.201 9.5918 20C9.5918 25.799 14.2928 30.5 20.0918 30.5ZM20.0918 25.25C17.1923 25.25 14.8418 22.8995 14.8418 20C14.8418 17.1005 17.1923 14.75 20.0918 14.75C22.9913 14.75 25.3418 17.1005 25.3418 20C25.3418 22.8995 22.9913 25.25 20.0918 25.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEightball);
export default __webpack_public_path__ + "static/media/Eightball.39aa5ae1.svg";
export { ForwardRef as ReactComponent };